export enum WorkflowSteps {
  Add = 1,
  Size,
  Configure,
  MyProjects,
}
